// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__dbiCF","employee-header-item":"Header_employee-header-item__60y62"};